module.exports = "/dashboard/components/groupSectionHeader-fa0be2.html";